import * as S from "./ModalHealthDetail.style";
import { Grid } from "@/components/molecules/Grid";
import { Buttons } from "@/components/atoms/Buttons";
import { UnitText } from "@/components/atoms/UnitText";
import { healthData } from "@/data/healthData";
import { ModalProps, Modals } from "..";

interface ModalHealthDetailProps extends ModalProps {
  subject?: string;
}

export const ModalHealthDetail = ({
  subject,
  setModalShow,
}: ModalHealthDetailProps) => {
  return (
    <Modals
      setModalShow={setModalShow}
      title={
        <>
          {subject === "sitAndReach"
            ? "윗몸 앞으로 굽히기 검사"
            : subject === "gribStrength"
            ? "악력"
            : subject === "bmi"
            ? "BMI"
            : subject === "skeletalMuscleMass"
            ? "골격근량"
            : subject === "bodyFatPercentage"
            ? "체지방률"
            : ""}{" "}
          <UnitText subject={subject} />
        </>
      }
      modalButtons={
        <>
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="닫기"
            onClick={() => setModalShow(false)}
          />
        </>
      }
    >
      <S.ModalHealthDetailContent>
        <Grid
          data={
            subject === "sitAndReach"
              ? healthData[0].data
              : subject === "gribStrength"
              ? healthData[1].data
              : subject === "bmi"
              ? healthData[2].data
              : subject === "skeletalMuscleMass"
              ? healthData[3].data
              : subject === "bodyFatPercentage"
              ? healthData[4].data
              : ""
          }
        />
        <S.SrcText>
          출처 :
          {subject === "sitAndReach" ? (
            <a
              href="https://www.schoolhealth.kr/web/search/selectTotalSearchList.do?bbsTyCode=BBST01&bbsId=&lstnum1=3544&pageIndex=1&sortOrder=&pageUnit=10&searchWrd=%EC%B2%B4%EB%A0%A5%ED%8F%89%EA%B0%80&dataGbn1=0101"
              target="_blank"
              rel="noreferrer noopener"
            >
              학생건강체력평가(PAPS) 기준표
            </a>
          ) : subject === "gribStrength" ? (
            <a
              href="https://www.schoolhealth.kr/web/search/selectTotalSearchList.do?bbsTyCode=BBST01&bbsId=&lstnum1=3544&pageIndex=1&sortOrder=&pageUnit=10&searchWrd=%EC%B2%B4%EB%A0%A5%ED%8F%89%EA%B0%80&dataGbn1=0101"
              target="_blank"
              rel="noreferrer noopener"
            >
              학생건강체력평가(PAPS) 기준표
            </a>
          ) : subject === "bmi" ? (
            <a
              href="https://health.kdca.go.kr/healthinfo/biz/health/gnrlzHealthInfo/gnrlzHealthInfo/gnrlzHealthInfoView.do?cntnts_sn=5292"
              target="_blank"
              rel="noreferrer noopener"
            >
              질병관리청 국가건강 정보 포털
            </a>
          ) : subject === "skeletalMuscleMass" ? (
            <span>남-체중 × 약 45% / 여-체중 × 약 36%</span>
          ) : subject === "bodyFatPercentage" ? (
            <a
              href="https://www.schoolhealth.kr/web/search/selectTotalSearchList.do?bbsTyCode=BBST01&bbsId=&lstnum1=3544&pageIndex=1&sortOrder=&pageUnit=10&searchWrd=%EC%B2%B4%EB%A0%A5%ED%8F%89%EA%B0%80&dataGbn1=0101"
              target="_blank"
              rel="noreferrer noopener"
            >
              학생건강체력평가(PAPS) 기준표
            </a>
          ) : (
            ""
          )}
        </S.SrcText>
      </S.ModalHealthDetailContent>
    </Modals>
  );
};
